var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    _vm.buildClasses(),
    _vm.data.el_class,
    _vm.data.animation_in ? ("animate__animated animate__" + (_vm.data.animation_in) + " animate__delay-1s") : '',
    _vm.data.animation_delay ? ("animate__delay-" + (_vm.data.animation_delay) + "s") : '',
    _vm.data.animation_infinite ? "animate__infinite" : '' ],attrs:{"id":_vm.data.el_id}},[_c('div',{staticClass:"MagCeColumn h-100",class:_vm.data.el_inner_class},[_vm._l((_vm.data.elements),function(element,key){return [_c('MagContentRenderer',{key:key,attrs:{"data":element}})]})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }